import type { XMediaPartialType } from '@/components/pages/content/types';

import { TW_POST_TYPES } from '@/lib/posts/postTypes';

import { PostTypeBadge } from '@/components/base/Post/TwitterPost/PostTypeBadge';

type InitialAuthorSectionProps = {
    data: XMediaPartialType;
    isExport: boolean;
};

export const InitialAuthorSection = ({ data, isExport }: InitialAuthorSectionProps) => {
    const hasInitialAuthor = data?.initial_author;
    const isSpecialType =
        data?.type === TW_POST_TYPES.TYPE_RETWEET ||
        data?.type === TW_POST_TYPES.TYPE_QUOTE ||
        data?.type === TW_POST_TYPES.TYPE_REPLY;

    if (!hasInitialAuthor || !isSpecialType) {
        return null;
    }

    return (
        <div className="mb-5 flex flex-wrap items-center space-x-1 text-xs">
            <PostTypeBadge type={data?.type ?? null} isExport={isExport} />
            {data?.initial_author?.tag && (
                <a href={data?.initial_author?.permalink} className="text-icoBlue">
                    {data?.initial_author?.tag}
                </a>
            )}
        </div>
    );
};
